module.exports = __webpack_public_path__ + "img/img01.30e5ef27.png";